module.exports = __webpack_public_path__ + "static/media/20180524-LCS-028-16.9d77746f.jpg";